import { render, staticRenderFns } from "./PageBodyMeasurements.vue?vue&type=template&id=3f1da847"
import script from "./PageBodyMeasurements.vue?vue&type=script&lang=js"
export * from "./PageBodyMeasurements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports